import { useState, useRef, useCallback } from 'react';
import { normalizePosition } from './helpers.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const useSlider = (props) => {
  const { min, max, width = 300, onChange } = props;
  const [positions, setPositions] = useState({ min, max });
  const rangeRef = useRef({ min, max });
  const getMinPosition = useCallback((position) => {
    const minPosition = normalizePosition(position, min, max, width);
    rangeRef.current = __spreadProps(__spreadValues({}, rangeRef.current), { min: minPosition });
    setPositions(__spreadProps(__spreadValues({}, positions), { min: position }));
    onChange == null ? void 0 : onChange(rangeRef.current);
  }, [min, max, positions, onChange, width]);
  const getMaxPosition = useCallback((position) => {
    const maxPosition = normalizePosition(position, min, max, width);
    rangeRef.current = __spreadProps(__spreadValues({}, rangeRef.current), { max: maxPosition });
    setPositions(__spreadProps(__spreadValues({}, positions), { max: position }));
    onChange == null ? void 0 : onChange(rangeRef.current);
  }, [min, max, positions, onChange, width]);
  return {
    positions,
    getMinPosition,
    getMaxPosition
  };
};

export { useSlider };
//# sourceMappingURL=useSlider.es.js.map
